/* eslint-disable @typescript-eslint/no-explicit-any */
import { BehaviorSubject } from 'rxjs';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Product } from '../interfa/product-detail';
import { take, map } from 'rxjs/operators';

import { AppService } from '../api.service';
import { ProjectsService } from './project.service';
import { isPlatformBrowser } from '@angular/common';
import { LocalStorageService } from './localstorage.service';

@Injectable({
  providedIn: 'root',
})
export class AddToCartService {
  cart_data: any;
  product_count: any;
  constructor(@Inject(PLATFORM_ID) private platformId: object,public _project: ProjectsService, private _as: AppService,private localStorageService: LocalStorageService) {
    if(isPlatformBrowser(platformId)){
      let existingCartItems:any;
      try{
        existingCartItems = JSON.parse(this.localStorageService.getItem('products')|| '');
      }catch{
        existingCartItems = null
      }
    if (!existingCartItems) {
      existingCartItems = [];
    }
    this.itemsSubject.next(existingCartItems);}
  }

  private itemsSubject = new BehaviorSubject<Product[]>([]);
  items$ = this.itemsSubject.asObservable();

  addToCart(product: Product) {
    this.items$.pipe(
      take(1),
      map((products) => {
        products.push(product);
        this.localStorageService.setItem('products', JSON.stringify(products));
      }),
    ).subscribe();
  }
  checkCart() {
    if (this._as.isUserLoggedIn) {
      const project_id = this._project.getProjectId();
      const form_type = "search"
      const url = this._as.api_base_url + `user/check-cart/?project=` + project_id + `&form_type=` + form_type;
      this._as.getRequest(url, true)
        .subscribe((res: any) => {
          this.cart_data = res.data;
          this.product_count = res.data.product_count
        })
    }
  }
}